/**
 * Empty State Message
 * Reusable message component for empty/no-selection states
 */

import { makeStyles, tokens, Text, Caption1 } from '@fluentui/react-components'
import { DocumentSearchRegular } from '@fluentui/react-icons'
import type { ReactNode } from 'react'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: tokens.spacingVerticalXXL,
    textAlign: 'center',
    gap: tokens.spacingVerticalM,
  },
  icon: {
    fontSize: '48px',
    color: tokens.colorNeutralForeground4,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: tokens.spacingVerticalXS,
  },
  title: {
    color: tokens.colorNeutralForeground2,
  },
  description: {
    color: tokens.colorNeutralForeground3,
  },
})

export interface EmptyStateMessageProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
}

export function EmptyStateMessage({ icon, title, description, action }: EmptyStateMessageProps) {
  const styles = useStyles()

  return (
    <div className={styles.root}>
      <div className={styles.icon} aria-hidden="true">{icon ?? <DocumentSearchRegular />}</div>
      <div className={styles.textContainer}>
        <Text weight="semibold" className={styles.title}>
          {title}
        </Text>
        {description && <Caption1 className={styles.description}>{description}</Caption1>}
      </div>
      {action}
    </div>
  )
}
